<template>
  <div class="box">
    <div class="top">
      <div class="tit">公益联盟</div>
      <div class="border"></div>
      <div class="back"
           @click="back">
        <img src="../../assets/images/back.png"
             alt="" />
        <span>返回</span>
      </div>
    </div>
    <div class="content">
      <div class="list">
        <nav>
          <div :class="[
              select2Index == item.id ? 'on' : '',
              index == 3 ? 'on3' : index == 0 ? 'on2' : '',
              'navitem',
            ]"
               v-for="(item, index) in nav2list"
               :key="index"
               @click="change2(index, item.id)">
            {{ item.name }}
          </div>
        </nav>
        <template v-if="list.length>0">
          <div class="item"
               v-for="item in list"
               :key="item.id"
               @click="GoDetail(item.id)">
            <img :src="baseUrl + item.logo"
                 alt="" />
            <div>
              {{ item.orgName }}
            </div>
          </div>
        </template>
        <div v-else
             style="color:#FFE1CE;font-size:30px;font-weight:600;margin-top: 200px;text-align: center;">暂无相关数据</div>
        <Pagination style="position:absolute;bottom:95px"
                    v-if="total>0"
                    ref="pagination"
                    :total="total"
                    :size="5"
                    :page.sync="page"
                    @pagination="changePage" />
      </div>
    </div>
    <div class="bg"></div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination";
export default {
  data () {
    return {
      select1: "",
      select2: "",
      selectList1: [],
      selectList2: [],
      selectIndex: 0,
      select2Index: 0,
      type: "",
      page: 1,
      total: 0,
      navlist: [],
      nav2list: [
        { name: "全部", id: "" },
        { name: "社会组织", id: 1 },
        { name: "校企", id: 2 },
        { name: "基金会", id: 3 },
      ],
      list: [],
      baseUrl: "",
    };
  },

  components: {
    Pagination,
  },

  computed: {},

  create () { },

  mounted () {
    this.getSelectList();
  },

  methods: {
    // 返回
    back () {
      this.$router.go(-1);
    },
    // 获取下拉菜单列表
    getSelectList () {
      this.baseUrl = this.$baseUrl;
      let url = this.$baseUrl + "/system/dictController/queryDictByKeyParent";
      let postData = {
        key: "serviceType",
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.selectList1 = res.data;
          this.select2 = "";
          this.getList();
        })
        .catch(() => { });
    },
    // 切换页码
    changePage (page) {
      this.page = page;
      this.getList();
    },
    // 获取数据列表
    getList () {
      let url =
        this.$baseUrl +
        "/system/wechat/kyyOrganizationPcController/selectKyyPublicWelfare";
      let postData = {
        page: this.page,
        limit: 5,
        type: this.type,
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.list = res.data.list;
          this.total = res.data.total;
          this.nav2list[0].num = res.data.all;
          this.nav2list[1].num = res.data.noStart;
          this.nav2list[2].num = res.data.signUp;
          this.nav2list[3].num = res.data.execution;
          this.nav2list[4].num = res.data.knot;
        })
        .catch(() => { });
    },
    // 切换项目状态
    change2 (index, id) {
      this.select2Index = index;
      this.type = id;
      this.page = 1;
      this.getList();
    },
    // 去详情
    // GoDetail(id) {
    //   this.$router.push({path:'/projectDetails',query: {id}})
    // },
  },
};
</script>
<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
  .top {
    height: 92px;
    overflow: hidden;
    position: relative;
    background: url("../../assets/images/pageHome/topTitle.png") no-repeat
      center/100% 100%;
    .tit {
      height: 33px;
      width: 300px;
      line-height: 33px;
      margin-top: 27px;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fff;
      // background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
      -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      margin-left: 886px;
    }
    .back {
      z-index: 9;
      position: absolute;
      top: 31px;
      right: 43px;
      font-size: 24px;
      font-weight: 400;
      color: #1080d0;
      cursor: pointer;
      img {
        width: 20px;
        height: 21px;
        margin-right: 9px;
      }
    }
  }
  .content {
    display: flex;
    height: 966px;
    padding-top: 30px;
    // background: url("../../assets/images/nrq11.png") no-repeat center/100% 100%;
    .nav {
      margin-left: 32px;
      margin-top: 3px;
      .title {
        width: 198px;
        display: block;
        height: 90px;
        cursor: pointer;
      }
      .navlist {
        margin-top: -5px;
        padding: 18px 0;
        background: url("../../assets/images/orgTaber.png") no-repeat
          center/100% 100%;
        width: 196px;
        height: 100%;
        .on {
          color: #ffffff !important;
        }
        .item {
          width: 190px;
          text-align: center;
          cursor: pointer;
          margin-bottom: 33px;
          height: 23px;
          line-height: 24px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
    .list {
      height: 876px;
      margin: 0 auto;
      margin-top: 20px;
      z-index: 10;
      nav {
        display: flex;
        margin: -35px auto 37px;
        // width: 1088px;
        .navitem {
          width: 460px;
          height: 79px;
          // background: url("../../assets/images/navBg2.png") no-repeat center/100% 100%;
          background: linear-gradient(0deg, #064085, #0e69e4);
          border: 1px solid;
          font-size: 32px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 79px;
          text-align: center;
          cursor: pointer;
          overflow: hidden;
          border-top: 0;
          border-bottom: 0;
        }
        .on {
          font-size: 34px;
          font-weight: bold;
          color: #ffffff;
          background: #092f5d;
          box-shadow: 0px 2px 2px 0px #082b52;
          opacity: 0.8;
          border-top: 0;
          border-bottom: 0;
        }
        .on2 {
          border-radius: 14px 0px 0px 14px;
          border: 1px solid;
          border-top: 0;
          border-bottom: 0;
        }
        .on3 {
          border: 1px solid;
          border-radius: 0px 14px 14px 0px;
          border-top: 0;
          border-bottom: 0;
        }
      }
      .item {
        height: 120px;
        display: flex;
        background: url("../../assets/images/itemBg1.png") no-repeat center/100%
          100%;
        padding-left: 20px;
        position: relative;
        width: 1780px;
        margin: 0 auto;
        margin-bottom: 10px;
        align-items: center;
        cursor: pointer;
        img {
          width: 89px;
          height: 89px;
        }
        div {
          font-size: 46px;
          font-weight: bold;
          color: #ffffff;
          margin-left: 75px;
        }
      }
    }
  }
  .bg {
    // width: 1782px;
    // height: 1000px;
    // background: url("../../assets/images/nrq.png") no-repeat center/100% 100%;
    // position: absolute;
    // right: -4px;
    // bottom: 0;

    width: 1850px;
    height: 910px;
    background: url("../../assets/images/nrq.png") no-repeat center/100% 100%;
    position: absolute;
    right: 35px;
    bottom: 56px;
  }
}
</style>